import join from 'url-join';
import { ArticleFragmentResponse } from '../../../../fragments/article';
import useSiteMetadata from '../../../Seo/useSiteMetadata';

export const PRIMARY_IMAGE_HASH = '#primaryimage';

const useImageObject = (article: ArticleFragmentResponse) => {
  const { siteUrl } = useSiteMetadata();

  const { slug, image } = article;
  const { asset, alt } = image || {};
  const { src, width, height } = asset?.localFile?.childImageSharp?.original || {};

  if (slug?.current && src) {
    return {
      '@type': 'ImageObject',
      '@id': join(siteUrl, slug?.current, PRIMARY_IMAGE_HASH),
      caption: alt,
      url: src,
      width: {
        '@type': 'QuantitativeValue',
        value: width,
      },
      height: {
        '@type': 'QuantitativeValue',
        value: height,
      },
    };
  }

  return undefined;
};

export default useImageObject;
